import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "project-page" }
const _hoisted_2 = { class: "project-layout" }
const _hoisted_3 = { class: "main-content" }
const _hoisted_4 = { class: "project-search-bar" }
const _hoisted_5 = {
  class: "project-table-bar",
  style: {"text-align":"right","margin-bottom":"8px"}
}
const _hoisted_6 = { class: "project-pagination" }

import { ref, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import SystemSideMenu from '@/components/SystemSideMenu.vue'
import { SearchOutlined, ReloadOutlined } from '@ant-design/icons-vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectManager',
  setup(__props) {

const selectedKeys = ref(['project'])
const openKeys = ref(['system'])
const router = useRouter()
const route = useRoute()

// 页面加载和路由变化时自动高亮
watch(
  () => route.path,
  (path) => {
    if (path === '/system/project') selectedKeys.value = ['project']
    else if (path === '/system/systemConfig/user-mgr') selectedKeys.value = ['user-mgr']
    else if (path === '/system/systemConfig/feedback') selectedKeys.value = ['feedback']
    else if (path === '/system/systemConfig/sync') selectedKeys.value = ['sync']
    else selectedKeys.value = []
    openKeys.value = ['system']
  },
  { immediate: true }
)

function onMenuSelect({ key }: { key: string }) {
  selectedKeys.value = [key]
  if (key === 'user-mgr') router.push('/system/systemConfig/user-mgr')
  else if (key === 'feedback') router.push('/system/systemConfig/feedback')
  else if (key === 'sync') router.push('/system/systemConfig/sync')
  else if (key === 'project') router.push('/system/systemConfig/project')
  // 其它菜单可按需跳转
}

const columns = [
  { title: '项目ID', dataIndex: 'id', key: 'id' },
  { title: '项目名称', dataIndex: 'name', key: 'name' },
  { title: '管理员', dataIndex: 'admin', key: 'admin' },
  { title: '是否启用', dataIndex: 'enabled', key: 'enabled' },
  { title: '区域数', dataIndex: 'areaCount', key: 'areaCount' },
  { title: '设备数', dataIndex: 'deviceCount', key: 'deviceCount' },
  { title: '操作', key: 'action' }
]

const dataSource = [
  {
    id: '17868387179804222144',
    name: '默认项目',
    admin: 'administrator',
    enabled: '是',
    areaCount: 0,
    deviceCount: 0
  }
]

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "project-title" }, "项目管理", -1)),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_a_form, { layout: "inline" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, { label: "项目名称" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        placeholder: "请输入项目名称",
                        style: {"width":"180px"}
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, { label: "项目ID" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        placeholder: "请输入项目ID",
                        style: {"width":"180px"}
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        style: {"margin-right":"8px"}
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_unref(SearchOutlined))
                        ]),
                        default: _withCtx(() => [
                          _cache[0] || (_cache[0] = _createTextVNode(" 查询 "))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_button, null, {
                        icon: _withCtx(() => [
                          _createVNode(_unref(ReloadOutlined))
                        ]),
                        default: _withCtx(() => [
                          _cache[1] || (_cache[1] = _createTextVNode(" 重置 "))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_a_button, { type: "primary" }, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createTextVNode("+ 新增")
                ])),
                _: 1
              })
            ]),
            _createVNode(_component_a_table, {
              columns: columns,
              "data-source": dataSource,
              pagination: false,
              size: "middle"
            }, {
              bodyCell: _withCtx(({ column, record }) => [
                (column.key === 'action')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_a_button, {
                        type: "link",
                        size: "small",
                        style: {"margin-right":"8px"}
                      }, {
                        default: _withCtx(() => _cache[3] || (_cache[3] = [
                          _createTextVNode("编辑")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_a_button, {
                        type: "link",
                        size: "small",
                        style: {"margin-right":"8px","color":"#ff4d4f"}
                      }, {
                        default: _withCtx(() => _cache[4] || (_cache[4] = [
                          _createTextVNode("删除")
                        ])),
                        _: 1
                      })
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_6, [
              _cache[7] || (_cache[7] = _createElementVNode("span", null, "共1条", -1)),
              _createVNode(_component_a_pagination, {
                total: 1,
                pageSize: 10,
                current: 1,
                style: {"margin":"0 16px"}
              }),
              _createVNode(_component_a_select, {
                value: 10,
                style: {"width":"90px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select_option, { value: 10 }, {
                    default: _withCtx(() => _cache[5] || (_cache[5] = [
                      _createTextVNode("10条/页")
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: 20 }, {
                    default: _withCtx(() => _cache[6] || (_cache[6] = [
                      _createTextVNode("20条/页")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})